module.exports = {
  defaultLocale: 'de',
  locales: ['de'],
};
